module.exports = __webpack_public_path__ + "img/yowhatsapp.e0584af4.webp";